import EntryEditable from './EntryEditable';
import EntryEditableWithUnit from './EntryEditableWithUnit';
import EntryConst from './EntryConst';

const PredefinedPosition = ({ col, item, index, onChange, onUnitChange }) => {
  const isPosition = col.key === `position${item.depth}`;

  return (
    <>
      {col.custom && <>{col.custom(item, col.unit)}</>}
      {isPosition && (
        <EntryConst
          value={item.position}
          unit=""
          className={col.className}
          item={item}
        />
      )}
      {col.key === 'name' && (
        <EntryConst
          value={item[col.key]}
          unit=""
          className={col.className}
          item={item}
        />
      )}
      {col.key === 'amount' && (
        <EntryEditableWithUnit
          col={col}
          item={item}
          onChange={onChange}
          onUnitChange={onUnitChange}
        />
      )}
      {(col.key === 'taxRate' || col.key === 'price') && (
        <EntryEditable col={col} item={item} onChange={onChange} />
      )}
    </>
  );
};

export default PredefinedPosition;
